'use strict';

import config from '../../js/config';
import $ from 'jquery';
import * as featureFlags from '../../utilities/featureFlags';
import * as globalisation from '../../utilities/globalisation';
import { getLogger } from 'loglevel';
import cartApi from '../../services/CartAPI';
import { jQueryRefreshToken } from '../../utilities/requestFetchMiddleware';
import cookies from 'js-cookie';

const log = getLogger('loginAPI');

class LoginAPI {
  login(username, password) {
    let postData = {
      username: username,
      password: password
    };

    return $.ajax({
      type: 'POST',
      url: config.urls.login.arrow,
      data: postData,
      contentType: 'application/x-www-form-urlencoded'
    }).then((data, textStatus, request) => {
      let headerCurrentUserFirstName = request.getResponseHeader('currentUserFirstName');
      if (headerCurrentUserFirstName) {
        window.localStorage.currentUserFirstName = headerCurrentUserFirstName;
      }
      if (!featureFlags.EnableHybrisIntegration.isEnabled() || !data || !data.data || !data.data.success) {
        return data.data;
      }
      return jQueryRefreshToken().then(
        (hybrisData) => {
          if (hybrisData.access_token) {
            if (window && window.Arrow) {
              window.Arrow.isAuthorized = true;
            }
          }
          return data.data;
        },
        () => {
          // FIXME: hard code error message for now.
          // hybris error message will come from hybris server side in the future
          return $.when({
            success: false,
            showModal: false,
            modalMessage: globalisation.pluraliseAndTranslate('customerSupport', 'lockedOutMessage'),
            modalTitle: globalisation.pluraliseAndTranslate('customerSupport', 'lockedOutTitle'),
            redirectUrl: null,
            domainAuthenticationUrls: null
          });
        })
        .then((response) => {
          let d = $.Deferred();
          cartApi.mergeCart().then(
            () => {
              d.resolve(response);
            },
            () => {
              log.error('merge cart fail');
              d.resolve(response);
            });
          return d.promise();
        });
    });
  }

  getCrossDomainLogin(data) {
    return data.domainAuthenticationUrls.map(urlToCall => {
      let defObj = $.Deferred();
      $.ajax({
        type: 'POST',
        url: urlToCall,
        data: null,
        xhrFields: { withCredentials: true },
        contentType: 'application/x-www-form-urlencoded'
      })
        .then(
          (data) => defObj.resolve(data),
          (jqXHR,textStatus,errorThrown) => {
            log.error('LoginAPI: Crossdomainlogin failed ' + errorThrown);
            return defObj.resolve()
          }
        );
      return defObj.promise();
    });
  }

  setLoyaltyPreference(loyaltyUrl, userId, optIn, emailPreference) {
    let token = cookies.get(config.cookies.accessToken);
    let postData = JSON.stringify({ 'userId': userId, 'subscribe': optIn, 'emailSubscriptionPreference': emailPreference });
    let defObj = $.Deferred();
    $.ajax({
      type: 'POST',
      url: `${loyaltyUrl}?fields=FULL`,
      data: postData,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      headers: { 'authorization': 'Bearer ' + token },
      handleErrorLocally: true
    })
      .then(
        (data) => defObj.resolve(data),
        (jqXHR,textStatus,errorThrown) => {
          log.error('LoginAPI: LoyaltyOptin failed ' + errorThrown);
          return defObj.resolve()
        });
    let promiseArray = [];
    promiseArray.push(defObj.promise());
    return promiseArray
  }
}
module.exports = new LoginAPI();



// WEBPACK FOOTER //
// ./assets/components/Login/LoginAPI.js